import React, { act, useEffect, useState } from "react";
import FormStrip from "../../components/FormStrip";
import HeaderContent from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { useTranslation } from "react-i18next";
import { PortalWrapper, SideWrapper, MainWrapper, PrimaryTabsWrapper, PrimaryTabs, PrimaryTab } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory, useLocation } from "react-router-dom";
import { citizenBaseUrl, Sidebarlabels } from "../../components/data";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { ScrutinyUnderProcess } from "../../reusableComponents/ScrutinyLoader";
import SubStep1 from "./SubStep1";
import SubStep2 from "./SubStep2";
import { SubTab, SubTabs, SubTabsWrapper } from "../../../TCPForms/forms/StyledComponents";
import getFormSuggestionData from "./getFormSuggestionData";
import { Box } from "@material-ui/core";

const FormSuggestionPortal = () => {
  const dispatch = useDispatch();
  console.log("insideformSuggestionnewform");

  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  // let applicationData = location.state?.data;
  const [, applicationFlow] = useDepartmentSelector();
  //   const [selectedSubTab, setSelectedSubTab] = useState(
  //   Digit.SessionStorage.get("FORM_SUGGESTION_SUBTAB") || 0
  // );
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("FORM_SUGGESTION_TAB") || 0);
  const [proposedSite, setProposedSite] = useState(null);
  const { applicationData, isAppDataLoading } = getFormSuggestionData(t, id);
  const { info: userInfo } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PRESSRELEASE", applicationData);

  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const handleTabChange = (nextTab, formData) => {
    console.log("nextTabFormData", formData, activeTab, nextTab);
    if (formData) {
      if (activeTab === 0 && formData && !formData?.applicationNo) {
        const data = {
          ...params,
          ...formData,
          pressReleaseAmount: Number(params?.pressReleaseFee || formData?.pressReleaseFee || params?.additionalDetails?.pressReleaseFee || formData?.additionalDetails?.pressReleaseFee),
          businessService: "BPA_PRESS_RELEASE",
        };
        data.oldMapSubApplNumber = data.applicationNo;
        delete data.applicationNo;
        delete data.pressReleaseFee;

        data.workflow = {
          action: "INITIATE",
          assignes: null,
        };
        Digit.OBPSService.createLandUseUP({ LandUse: data }, tenantId)
          .then((res) => {
            console.log("createLandUseUPResponse", res, res?.LandUse?.length);
            if (res?.LandUse?.[0]?.applicationNo) {
              onSelect("", { ...formData, ...res.LandUse[0] }, "", true);
              Modal("Application Created", `Application created Successfully!`, "success");
            }
            setActiveTab(nextTab);
            const updatedFormData = { ...formData, ...data };
            Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
            Digit.SessionStorage.set("FORM_PRESSRELEASE", updatedFormData);
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        const data = {
          ...params,
          ...formData,
          tenantId: params?.tenantId || tenantId,
        };
        try {
          let redirectUrl = null;
          let message = "";
          if (activeTab === 1) {
            data.workflow = { action: "MAKE_PAYMENT", assignes: null };

            redirectUrl = `${citizenBaseUrl}/payment/collect/BPA.MAP_PRESSRELEASE_FEE/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`;

            message = `Application <strong>${data?.applicationNo}</strong> updated successfully, redirecting to payment page.`;
          } else {
            data.workflow = { action: "UPLOAD_DOC", assignes: null };

            redirectUrl = null;

            message = `Application <strong>${data?.applicationNo}</strong> updated successfully!`;
          }

          {
            updateApiCall.mutate(
              { LandUse: data },
              {
                onSuccess: (res) => {
                  onSelect("", res.LandUse[0]);
                  setActiveTab(nextTab);
                  Modal("Data has been saved successfully!", message, "success", redirectUrl);
                  Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
                },
                onError: () => {
                  Modal("Update Error", "Something went wrong!!", "error");
                },
              }
            );
          }
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
    }
  };

  // useEffect(() => {
  //   if (id && applicationData) {
  //     setParams((prev) => ({
  //       ...prev,
  //       ...applicationData,
  //     }));

  //     if (applicationData?.documents?.length > 0) {
  //       initFormMTDocs(applicationData.documents);
  //     }
  //   }
  // }, [id, applicationData]);

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <SubStep1
            formData={params}
            userInfo={userInfo}
            handleTabChange={handleTabChange}
            setProposedSite={setProposedSite}
            schemeTypeData={schemeTypeData}
            nonSchemeTypeData={nonSchemeTypeData}
            id={id}
          />
        );
      case 1:
        return <SubStep2 formData={params} userInfo={userInfo} id={id} tenantId={tenantId} handleTabChange={handleTabChange} />;
      default:
        return null;
    }
  };

  return (
    // <div>Hey World</div>
    <Box sx={{ boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", overflowY: "auto", padding: "20px" }} className="bg-white">
      <div className="formStripLandUse mb-3 border-0">
        <h2>Invitation/Suggestion Form</h2>
      </div>
      <div className="main-panel-corner land-use-corner">
        <div className="left-corner">
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              <PrimaryTab label="Application Form" />
              <PrimaryTab label="Fees" />

              {/* <PrimaryTab label="Letter and Plan" /> */}
            </PrimaryTabs>
          </PrimaryTabsWrapper>
        </div>
        {renderContent()}

        {/* <StyledDivider /> */}
      </div>
    </Box>
  );
};

export default FormSuggestionPortal;
